module.exports = __webpack_public_path__ + "img/morocco.ac4335ce.svg";